import { DataCollectorInstance, TransactionCollector } from '@scfe-common/core';
import { handleResponseData } from '../../utils';
import { ActionType, RequestState } from '@scfe-common/chain-tracker';
import { SLA_CHAINS_TYPE } from '@/utils/chain-tracker/constants';
import { CustomActionType } from '@/utils/chain-tracker/plugins/types';

export default [
  {
    name: 'SLASaleInboundBoxing',
    status: {
      errorCount: 0,
    },
    collector: {} as TransactionCollector,
    ALLName: 'custom_InboundBoxing',
    PieceByPieceSKU: 'custom_InboundBoxing_piece_by_piece_sku',
    NoPieceByPieceSKU: 'custom_InboundBoxing_no_piece_by_piece_sku',
    ErrorCount: 'custom_InboundBoxing_error_count',
    scanSKUTime: 'custom_InboundBoxing_scan_SKU_time',
    scanSKUErrorCount: 'custom_InboundBoxing_scan_SKU_time_error_count',
    scanASNTime: 'custom_InboundBoxing_scan_ASN_time',
    scanASNErrorCount: 'custom_InboundBoxing_scan_ASN_time_error_count',
    scanDeviceTime: 'custom_InboundBoxing_scan_device_time',
    scanDeviceErrorCount: 'custom_InboundBoxing_scan_device_time_error_count',
    getPointList: function () {
      return [
        // boxing 任务开始
        {
          type: CustomActionType.Focus,
          rule: {
            selectors: '#inbound-boxing-input-asnId',
          },
          handler: () => {
            this.collector = DataCollectorInstance.createTransactionCollector();
            this.collector.startTrack({
              name: this.scanASNTime,
            });
          },
        },
        {
          type: ActionType.REQUEST,
          rule: {
            url: /^\/api\/v2\/apps\/process\/inbound\/poboxing\/scan_sheet_id(\?.*)?$/,
            state: RequestState.Before,
          },
          handler: () => {
            this.collector.startTrack({
              name: this.ALLName,
            });
            this.status.errorCount = 0;
          },
        },
        {
          type: ActionType.REQUEST,
          rule: {
            url: /^\/api\/v2\/apps\/process\/inbound\/poboxing\/scan_sheet_id(\?.*)?$/,
            state: RequestState.After,
          },
          handler: (trackData: any, sendDataFn: any) => {
            const response = handleResponseData(trackData);

            const [result] = this.collector.endTrackByName({
              name: this.scanASNTime,
              isSuccess: true,
            });

            sendDataFn({
              pointId: result.name,
              customData: { ...result, type: 'experienceTime' },
            });
            sendDataFn({
              pointId: this.scanASNErrorCount,
              customData: {
                errorCount_n: Number(response?.retcode !== 0),
                type: 'experienceCount',
              },
            });
          },
        },
        {
          type: CustomActionType.Focus,
          rule: {
            selectors: '#inbound-boxing-input-deviceId',
          },
          handler: () => {
            this.collector.startTrack({
              name: this.scanDeviceTime,
            });
          },
        },
        {
          type: ActionType.REQUEST,
          rule: {
            url: /^\/api\/v2\/apps\/process\/inbound\/poboxing\/scan_box_id(\?.*)?$/,
            state: RequestState.After,
          },
          handler: (trackData: any, sendDataFn: any) => {
            const response = handleResponseData(trackData);

            const [result] = this.collector.endTrackByName({
              name: this.scanDeviceTime,
              isSuccess: true,
            });

            sendDataFn({
              pointId: result.name,
              customData: { ...result, type: 'experienceTime' },
            });
            sendDataFn({
              pointId: this.scanDeviceErrorCount,
              customData: {
                errorCount_n: Number(response?.retcode !== 0),
                type: 'experienceCount',
              },
            });
          },
        },
        {
          type: ActionType.CLICK,
          rule: {
            selectors: '#boxing-input-sku',
          },
          handler: () => {
            // this.collector.startTrack({
            //   name: this.PieceByPieceSKU,
            // });
            // this.collector.startTrack({
            //   name: this.NoPieceByPieceSKU,
            // });
            this.collector.startTrack({
              name: this.scanSKUTime,
            });
          },
        },
        {
          type: ActionType.REQUEST,
          rule: {
            url: /^\/api\/v2\/apps\/process\/inbound\/poboxing\/pre_scan_sku_id(\?.*)?$/,
            state: RequestState.After,
          },
          handler: (trackData: any, sendDataFn: any) => {
            const response = handleResponseData(trackData);

            const [result] = this.collector.endTrackByName({
              name: this.scanSKUTime,
              isSuccess: true,
            });

            sendDataFn({
              pointId: result.name,
              customData: { ...result, type: 'experienceTime' },
            });
            sendDataFn({
              pointId: this.scanSKUErrorCount,
              customData: {
                errorCount_n: Number(response?.retcode !== 0),
                type: 'experienceCount',
              },
            });
          },
        },

        // piece by piece 结束
        // {
        //   type: ActionType.REQUEST,
        //   rule: {
        //     url: /^\/api\/v2\/apps\/process\/inbound\/poboxing\/scan_and_save_sku(\?.*)?$/,
        //     state: RequestState.After,
        //   },
        //   handler: (trackData: any, sendDataFn: any) => {
        //     const response = handleResponseData(trackData);
        //     if (response?.retcode === 0) {
        //       const [result] = this.collector.endTrackByName({
        //         name: this.PieceByPieceSKU,
        //         isSuccess: true,
        //       });
        //       this.collector.endTrackByName({
        //         name: this.NoPieceByPieceSKU,
        //         isSuccess: true,
        //       });
        //       sendDataFn({
        //         pointId: result.name,
        //         customData: { ...result, type: 'experienceTime' },
        //       });
        //       sendDataFn({
        //         pointId: this.ErrorCount,
        //         customData: {
        //           errorCount_n: this.status.errorCount,
        //           type: 'experienceCount',
        //         },
        //       });
        //     }
        //   },
        // },
        // // no piece by piece 结束
        // {
        //   type: ActionType.REQUEST,
        //   rule: {
        //     url: /^\/api\/v2\/apps\/process\/inbound\/poboxing\/save_box_sku(\?.*)?$/,
        //     state: RequestState.After,
        //   },
        //   handler: (trackData: any, sendDataFn: any) => {
        //     const response = handleResponseData(trackData);
        //     if (response?.retcode === 0) {
        //       const [result] = this.collector.endTrackByName({
        //         name: this.NoPieceByPieceSKU,
        //         isSuccess: true,
        //       });
        //       this.collector.endTrackByName({
        //         name: this.PieceByPieceSKU,
        //         isSuccess: true,
        //       });
        //       sendDataFn({
        //         pointId: result.name,
        //         customData: { ...result, type: 'experienceTime' },
        //       });
        //     }
        //   },
        // },
        // 监听所有的请求报错
        {
          type: ActionType.REQUEST,
          rule: {
            url: /^\/api\/v2\/apps\/process\/inbound\/poboxing\//,
            state: RequestState.After,
          },
          handler: (trackData: any, _: any) => {
            const response = handleResponseData(trackData);
            if (response?.retcode !== 0) {
              this.status.errorCount += 1;
            }
          },
        },
        // boxing 结束
        {
          type: ActionType.REQUEST,
          rule: {
            url: /^\/api\/v2\/apps\/process\/inbound\/poboxing\/complete_box(\?.*)?$/,
            state: RequestState.After,
          },
          handler: (trackData: any, sendDataFn: any) => {
            const response = handleResponseData(trackData);
            if (response?.retcode === 0) {
              // 全流程耗时和错误数量上报
              const [allResult] = this.collector.endTrackByName({
                name: this.ALLName,
                isSuccess: true,
                endAll: true,
              });
              sendDataFn({
                pointId: allResult.name,
                customData: { ...allResult, type: 'experienceTime' },
              });
              sendDataFn({
                pointId: this.ErrorCount,
                customData: {
                  errorCount_n: this.status.errorCount,
                  type: 'experienceCount',
                },
              });
              DataCollectorInstance.removeTransactionCollector({
                traceId: this.collector.traceId,
              });
            }
          },
        },
      ];
    },
  },
];
